module.exports = __webpack_public_path__ + "media/Afgan feat Rossa - Kamu Yang Kutunggu.39682714.mp3";